/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDiamondIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-diamond"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.82 8.32L15.18 8.32L12.6 2.67L11.4 2.67ZM11.25 20.6L11.25 9.82L2.25 9.82ZM12.75 20.6L21.75 9.82L12.75 9.82ZM16.82 8.32L22 8.32L19.93 4.15Q19.57 3.48 18.94 3.08Q18.3 2.67 17.55 2.67L14.25 2.67ZM2 8.32L7.17 8.32L9.75 2.67L6.45 2.67Q5.7 2.67 5.06 3.08Q4.42 3.48 4.08 4.15Z" fill={color} />
    </svg>
  );
}
